var _path, _g, _g2, _rect, _rect2, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.06661 31.9338C0.0897017 20.7952 0.101248 15.2259 2.26642 10.971C4.19802 7.17506 7.29096 4.09492 11.0948 2.17907C15.3587 0.031565 20.928 0.0431108 32.0666 0.0662025C43.2052 0.0892942 48.7746 0.10084 53.0295 2.26601C56.8253 4.19761 59.9055 7.29055 61.8213 11.0944C63.9688 15.3583 63.9573 20.9276 63.9342 32.0662C63.9111 43.2048 63.8996 48.7741 61.7344 53.029C59.8028 56.8249 56.7099 59.9051 52.906 61.8209C48.6421 63.9684 43.0728 63.9569 31.9342 63.9338C20.7956 63.9107 15.2263 63.8992 10.9714 61.734C7.17547 59.8024 4.09533 56.7095 2.17948 52.9056C0.0319725 48.6417 0.0435183 43.0724 0.06661 31.9338Z",
    fill: "url(#paint0_linear_11452_90623)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_11452_90623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 27.0889C16 24.3844 16 23.0322 16.7046 22.008C16.7706 21.9122 16.8406 21.8193 16.9146 21.7296C17.7058 20.7707 19.006 20.3992 21.6065 19.6563C26.6845 18.2054 29.2236 17.48 31.8275 17.4311C32.0773 17.4264 32.3272 17.4264 32.577 17.4311C35.1809 17.48 37.7199 18.2054 42.798 19.6563C45.3984 20.3992 46.6987 20.7707 47.4898 21.7296C47.5638 21.8193 47.6339 21.9122 47.6998 22.008C48.4045 23.0322 48.4045 24.3844 48.4045 27.0889V30.7188C48.4045 38.2612 48.4045 42.0325 46.0613 44.3756C43.7182 46.7188 39.9469 46.7188 32.4045 46.7188H32C24.4575 46.7188 20.6863 46.7188 18.3431 44.3756C16 42.0325 16 38.2612 16 30.7188V27.0889Z",
    fill: "url(#paint1_linear_11452_90623)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_11452_90623)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7844 12C19.8669 12 18.3125 14.145 18.3125 16.7911V27.2763C25.1121 32.4345 28.691 37.435 32.2001 37.4605C35.7836 37.4867 39.2943 32.4299 46.0878 27.2763V16.7911C46.0878 14.145 44.5333 12 42.6159 12H21.7844Z",
    fill: "#BEB5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 16.7911C18.5625 15.5149 18.9377 14.3699 19.5318 13.55C20.1262 12.7298 20.9258 12.25 21.7844 12.25H42.6159C43.4745 12.25 44.2741 12.7298 44.8684 13.55C45.4626 14.3699 45.8378 15.5149 45.8378 16.7911V27.1524C43.4259 28.9902 41.4226 30.8177 39.6923 32.3961C39.0141 33.0147 38.3779 33.595 37.7755 34.1228C36.6905 35.0732 35.718 35.8509 34.8 36.3894C33.8833 36.9271 33.0369 37.2166 32.202 37.2106C31.3849 37.2046 30.5473 36.9091 29.6332 36.3686C28.7184 35.8277 27.7436 35.0515 26.6543 34.1045C26.0456 33.5754 25.4021 32.9936 24.7159 32.3731C22.9798 30.8035 20.9706 28.987 18.5625 27.1523V16.7911Z",
    stroke: "url(#paint2_linear_11452_90623)",
    strokeWidth: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.0195,
    y: 19.0703,
    width: 2.06461,
    height: 13.6376,
    rx: 1.0323,
    transform: "rotate(90 39.0195 19.0703)",
    fill: "url(#paint3_linear_11452_90623)",
    fillOpacity: 0.9,
    stroke: "url(#paint4_linear_11452_90623)",
    strokeWidth: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0195,
    y: 26.0117,
    width: 2.06461,
    height: 13.6376,
    rx: 1.0323,
    transform: "rotate(90 39.0195 26.0117)",
    fill: "url(#paint5_linear_11452_90623)",
    fillOpacity: 0.9,
    stroke: "url(#paint6_linear_11452_90623)",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1196 25.0079C47.4972 25.7191 47.7987 26.4748 48.0144 27.2632L32.9324 39.5173C32.5072 39.8628 31.898 39.8628 31.4728 39.5173L16.3906 27.2631C16.6064 26.4747 16.9078 25.719 17.2855 25.0078L32.2026 37.128L47.1196 25.0079Z",
    fill: "url(#paint7_linear_11452_90623)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6349 46.7499C52.4498 46.0816 52.4498 44.8168 51.6349 44.1485L45.7488 39.3213C44.6767 38.4421 43.0831 39.2197 43.0831 40.622V42.11H38.8845C37.9797 42.11 37.2461 42.8575 37.2461 43.7796V47.9536C37.2461 48.8757 37.9797 49.6233 38.8845 49.6233H43.0831V50.2765C43.0831 51.6787 44.6767 52.4563 45.7488 51.5772L51.6349 46.7499Z",
    fill: "url(#paint8_linear_11452_90623)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_11452_90623",
    x: 2.69473,
    y: 4.12246,
    width: 59.0168,
    height: 55.9016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65264
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_11452_90623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_11452_90623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_11452_90623",
    x: 5.00723,
    y: -1.30527,
    width: 54.384,
    height: 52.0715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65264
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_11452_90623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_11452_90623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11452_90623",
    x1: 32.0666,
    y1: 0.0662025,
    x2: 31.9342,
    y2: 63.9338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11452_90623",
    x1: 25.3474,
    y1: 23.2111,
    x2: 49.798,
    y2: 32.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2DAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11452_90623",
    x1: 33.3574,
    y1: 8.18092,
    x2: 32.8716,
    y2: 32.3587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996024,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11452_90623",
    x1: 40.4336,
    y1: 35.0223,
    x2: 40.4336,
    y2: 16.3802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11452_90623",
    x1: 34.5425,
    y1: 37.5309,
    x2: 44.5485,
    y2: 16.2416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11452_90623",
    x1: 38.3229,
    y1: 39.8924,
    x2: 40.3943,
    y2: 23.0915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11452_90623",
    x1: 35.9015,
    y1: 40.6402,
    x2: 43.9914,
    y2: 26.1635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11452_90623",
    x1: 16.6211,
    y1: 24.875,
    x2: 41.8729,
    y2: 43.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F2DAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11452_90623",
    x1: 52.2461,
    y1: 51.9492,
    x2: 37.2461,
    y2: 38.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2E6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9C35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.50f99d4fe93c0d5d7843552480279792.svg";
export { ForwardRef as ReactComponent };